import * as types from "@/redux/ActionTypes";
import Highcharts from "highcharts/highstock";
import { LanguageState } from "@/hooks/useLanguage";
// Window.LANG type is defined in src/types/global.d.ts

// Action interfaces
interface LanguageAction {
  type: typeof types.LANGUAGE;
  data: LanguageState;
}

interface DefaultAction {
  type: string;
  data?: unknown;
}

type Action = LanguageAction | DefaultAction;

const initialState: LanguageState = {};

const myReducer = (state: LanguageState = initialState, action: Action): LanguageState => {
  switch (action.type) {
    case types.LANGUAGE: {
      const langData = (action as LanguageAction).data;
      window.LANG = langData;
      // Using type assertion because Highcharts types don't include all lang options
      // that are actually supported by Highcharts at runtime
      Highcharts.setOptions({
        lang: {
          downloadCSV: langData.hc_downloadCSV_key,
          downloadJPEG: langData.hc_downloadJPEG_key,
          downloadMIDI: langData.hc_downloadMIDI_key,
          downloadPDF: langData.hc_downloadPDF_key,
          downloadPNG: langData.hc_downloadPNG_key,
          downloadSVG: langData.hc_downloadSVG_key,
          downloadXLS: langData.hc_downloadXLS_key,
          exitFullscreen: langData.hc_exitFullscreen_key,
          printChart: langData.hc_printChart_key,
          resetZoom: langData.hc_resetZoom_key,
          resetZoomTitle: langData.hc_resetZoomTitle_key,
          viewFullscreen: langData.hc_viewFullscreen_key,
        } as Highcharts.LangOptions,
      });
      return { ...langData };
    }
    default:
      return state;
  }
};

export default myReducer;
